import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';
import CardBodyWrapper from '../card-body-wrapper/card-body-wrapper.esm.js';
import { useCardContext } from '../card-context/card-context.esm.js';

var _excluded = ["canShrink", "children", "className", "alignItems", "direction", "fullHeight", "fullWidth", "gap", "gapCol", "gapRow", "justify", "paddingX", "paddingY", "scrollable", "stretch"];
var PrivateCardBody = /*#__PURE__*/forwardRef(function CardBody(props, ref) {
  var theme = useComponentTheme('Card');
  var canShrink = props.canShrink,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    alignItems = props.alignItems,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'vertical' : _props$direction,
    fullHeight = props.fullHeight,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? true : _props$fullWidth,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'lg' : _props$gap,
    gapCol = props.gapCol,
    gapRow = props.gapRow,
    justify = props.justify,
    paddingX = props.paddingX,
    paddingY = props.paddingY,
    _props$scrollable = props.scrollable,
    scrollable = _props$scrollable === void 0 ? true : _props$scrollable,
    stretch = props.stretch,
    rest = _objectWithoutProperties(props, _excluded);
  var _useCardContext = useCardContext(),
    padding = _useCardContext.padding,
    withDivider = _useCardContext.withDivider;
  // const id = usePropId(props.id)
  var classes = useMemo(function () {
    return theme.body({
      canShrink: canShrink,
      className: className,
      alignItems: alignItems,
      direction: direction,
      fullWidth: fullWidth,
      fullHeight: fullHeight,
      gap: gap,
      gapCol: gapCol,
      gapRow: gapRow,
      justify: justify,
      padding: padding,
      paddingX: paddingX,
      paddingY: paddingY,
      scrollable: scrollable,
      stretch: stretch,
      withDivider: !!withDivider
    });
  }, [canShrink, className, alignItems, direction, fullWidth, fullHeight, gap, gapCol, gapRow, justify, padding, paddingX, paddingY, scrollable, stretch, theme, withDivider]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    // id={id}
    ref: ref,
    className: "csg-tw-card-body ".concat(classes)
  }, rest), children);
});
var CardBody = Object.assign(PrivateCardBody, {
  displayName: 'Card.Body',
  Wrapper: CardBodyWrapper
});
var CardBody$1 = CardBody;

export { CardBody$1 as default };
//# sourceMappingURL=card-body.esm.js.map
